import TRACKING_EVENT_CATEGORIES from 'constants/trackingEventCategories';
import RESERVATIONS_VIEW_TYPES from 'constants/reservationsViewTypes';
import ERROR_MESSAGES from 'constants/errorMessages';
import SIDEBAR_LINKS from 'constants/sidebarLinks';
import WIDGET_DATA_TYPES from 'constants/widgetDataTypes';

function init(app) {
  if (!app) throw new Error('app is required');

  app.constant('TRACKING_EVENT_CATEGORIES', TRACKING_EVENT_CATEGORIES);
  app.constant('RESERVATIONS_VIEW_TYPES', RESERVATIONS_VIEW_TYPES);
  app.constant('ERROR_MESSAGES', ERROR_MESSAGES);
  app.constant('SIDEBAR_LINKS', SIDEBAR_LINKS);
  app.constant('WIDGET_DATA_TYPES', WIDGET_DATA_TYPES);
}

export default {
  init
};



// WEBPACK FOOTER //
// ./src/constants/index.js